import Services from 'services';

class TransferUpahWorkOrderApi {
  page(params) {
    return Services.get('/transfer_work_order_upah/page', { params });
  }

  preformPage(params) {
    return Services.get('/transfer_work_order_upah/work_order', { params });
  }

  singlePermintaanPreform(params) {
    return Services.get('/transfer_work_order_upah/detail_work_order', {
      params,
    });
  }

  singlePermintaan(params) {
    return Services.get('/transfer_work_order_upah/permintaan', { params });
  }

  no_baru(params) {
    return Services.get('/transfer_work_order_upah/no_baru', { params });
  }

  getDropdownUpah(params) {
    return Services.get('/dropdown/item_upah', { params });
  }

  getDropdownAset(params) {
    return Services.get('/dropdown/item_aset', { params });
  }

  getDropdownSubkon(params) {
    return Services.get('/dropdown/item_subkon', { params });
  }

  getDropdownVendor(params) {
    return Services.get('/dropdown/vendor', { params });
  }

  save(data) {
    return Services.post('/transfer_work_order_upah', data);
  }
}

export default new TransferUpahWorkOrderApi();
